import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    adminInfo: null
  },
  mutations: {
    updateAdminInfo (state, info) {
      state.adminInfo = info
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js